import axios from 'axios';
import api from '../common/api';

const basePath = '/mediaItems';
let cancelIt = null;
const FILMMAKER_VIDEO_DEFAULT_PARAMS = {
  offset: 0,
  limit: 20,
  sortBy: 'lastUpdated',
  sortOrder: 'desc'
};

const stopRequest = (reason = 'Superseded media items request') => {
  if (cancelIt) {
    cancelIt(reason);
  }
  cancelIt = null;
};
const buildFilmmakerVideoParams = ({
  searchText = '',
  filmmakerId = '',
  limit = FILMMAKER_VIDEO_DEFAULT_PARAMS.limit
} = {}) => {
  const params = {
    ...FILMMAKER_VIDEO_DEFAULT_PARAMS,
    limit
  };
  const normalizedSearchText = String(searchText || '').trim();
  const normalizedFilmmakerId = String(filmmakerId || '').trim();
  if (normalizedSearchText) {
    params.name = normalizedSearchText;
  }
  if (normalizedFilmmakerId) {
    params.availableForFilmmakerId = normalizedFilmmakerId;
  } else {
    params.unassignedForFilmmaker = true;
  }
  return params;
};
const filterOutAssociatedVideos = (mediaItems = [], associatedVideos = []) => {
  const associatedIds = new Set(
    associatedVideos
      .map((video) => String((video || {}).id || ''))
      .filter(Boolean)
  );
  return mediaItems.filter((video) => !associatedIds.has(String((video || {})._id || '')));
};

export default {
  createCancelSource() {
    return axios.CancelToken.source();
  },
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  getListWithViews(params = {}, requestConfig = {}) {
    stopRequest();
    const hasExternalCancelToken = !!requestConfig.cancelToken;
    const config = {
      params,
      ...requestConfig
    };
    if (!hasExternalCancelToken) {
      config.cancelToken = new axios.CancelToken((cancelRequest) => {
        cancelIt = cancelRequest;
      });
    }
    return api.get(`${basePath}/views`, config)
      .finally(() => {
        if (!hasExternalCancelToken) {
          cancelIt = null;
        }
      });
  },
  getFilmmakerVideoOptions(options = {}, requestConfig = {}) {
    const params = buildFilmmakerVideoParams(options);
    return this.getListWithViews(params, requestConfig);
  },
  filterOutAssociatedVideos(mediaItems = [], associatedVideos = []) {
    return filterOutAssociatedVideos(mediaItems, associatedVideos);
  },
  stopIt(reason = 'Cancelled media items request') {
    stopRequest(reason);
  },
  isItCanceled(error) {
    return (axios.isCancel && axios.isCancel(error)) || (error && error.code === 'ERR_CANCELED');
  },
  create(mediaItem) {
    return api.post(basePath, mediaItem);
  },
  get(mediaItemId, params = {}) {
    return api.get(`${basePath}/${mediaItemId}`, { params });
  },
  getImages(folderName) {
    return api.get(`${basePath}/get/images/${folderName}`);
  },
  delete(mediaItemId, params = {}) {
    return api.delete(`${basePath}/${mediaItemId}`, { params });
  },
  bulkDelete(data = []) {
    return api.delete(`${basePath}/bulk/delete`, { data });
  },
  deletePlaylistsAccountBulk(mediaItemIds = []) {
    return api.delete(`${basePath}/playlists/account`, { data: { mediaItemIds } });
  },
  update(mediaItemId, mediaItem) {
    return api.put(`${basePath}/${mediaItemId}`, mediaItem);
  },
  getFilterOptions(params = {}) {
    return api.get(`${basePath}/filters`, { params });
  },
  getAssociatedPlaylists(mediaItemId, params = {}) {
    return api.get(`${basePath}/associated/${mediaItemId}`, { params });
  },
  getMediaItemInfo(mediaItemId, params = {}) {
    return api.get(`${basePath}/info/${mediaItemId}`, { params });
  },
  getAssociatedSeries(seriesId) {
    return api.get(`${basePath}/associatedSeries/${seriesId}`);
  },
  getLicensesVideos(params = {}) {
    return api.get(`${basePath}/licenses`, { params });
  }
};



// WEBPACK FOOTER //
// ./src/services/mediaItemService.js